(function () {
  function PersonalizationScorer(signalsInstance) {
    this.signals = signalsInstance || window.personalizationSignals || null;

    this.WEIGHTS = {
      category: 0.3,
      vendor: 0.25,
      priceRange: 0.2,
      recentlyViewed: 0.15,
      searchRelevance: 0.1,
    };

    this.UTM_BONUS = 0.15;

    this.CAMPAIGN_KEYWORDS = {
      facebook_guitars: ['guitar', 'electric guitar', 'acoustic guitar'],
      google_drums: ['drum', 'drums', 'percussion', 'cymbal'],
      email_keyboards: ['keyboard', 'piano', 'synth', 'synthesizer'],
      instagram_bass: ['bass', 'bass guitar'],
    };
  }

  PersonalizationScorer.prototype.isAvailable = function () {
    if (!this.signals) return false;

    var data = this.signals.getSignals();
    return (
      data.viewedProducts.length > 0 ||
      Object.keys(data.categoryAffinity).length > 0 ||
      Object.keys(data.vendorAffinity).length > 0 ||
      data.searchTerms.length > 0
    );
  };

  PersonalizationScorer.prototype.getCampaignBonus = function (product, utm) {
    if (!utm || !utm.campaign) return 0;

    var keywords = this.CAMPAIGN_KEYWORDS[utm.campaign];
    if (!keywords || !keywords.length) return 0;

    var haystack = ((product.title || '') + ' ' + (product.productType || '')).toLowerCase();

    for (var i = 0; i < keywords.length; i += 1) {
      if (haystack.indexOf(keywords[i].toLowerCase()) !== -1) {
        return this.UTM_BONUS;
      }
    }

    return 0;
  };

  PersonalizationScorer.prototype.scoreProduct = function (product) {
    if (!this.signals) return 0;

    var score = 0;
    var signalData = this.signals.getSignals();

    score += this.signals.getCategoryAffinityScore(product.productType) * this.WEIGHTS.category;
    score += this.signals.getVendorAffinityScore(product.vendor) * this.WEIGHTS.vendor;
    score += this.signals.getPriceRangeScore(product.price) * this.WEIGHTS.priceRange;

    var viewedIndex = this.signals.getViewedIndex(product.id);
    if (viewedIndex !== -1) {
      var recencyScore = 1 - viewedIndex / Math.max(signalData.viewedProducts.length, 1);
      score += recencyScore * this.WEIGHTS.recentlyViewed;
    }

    var searchText = [product.title, product.vendor, product.productType].join(' ');
    var matches = this.signals.getSearchTermMatches(searchText);
    if (matches > 0) {
      score += Math.min(1, matches / Math.max(signalData.searchTerms.length, 1)) * this.WEIGHTS.searchRelevance;
    }

    score += this.getCampaignBonus(product, signalData.utm);

    return Math.max(0, Math.min(1, score));
  };

  PersonalizationScorer.prototype.personalizeOrder = function (products, baseWeight) {
    if (!products || !products.length || !this.signals) return products;

    var manualWeight = typeof baseWeight === 'number' ? baseWeight : 0.7;
    var personalizedWeight = 1 - manualWeight;
    var maxPosition = Math.max(products.length, 1);

    var scored = products.map(
      function (product) {
        var personalScore = this.scoreProduct(product);
        var positionScore = (Number(product.position) / maxPosition) * manualWeight;
        var personalizedScore = (1 - personalScore) * personalizedWeight;

        return Object.assign({}, product, {
          personalizedScore: positionScore + personalizedScore,
          rawPersonalScore: personalScore,
        });
      }.bind(this)
    );

    scored.sort(function (a, b) {
      return a.personalizedScore - b.personalizedScore;
    });

    return scored;
  };

  window.PersonalizationScorer = PersonalizationScorer;
  window.personalizationScorer = new PersonalizationScorer(window.personalizationSignals);
})();
